import React, { useState, useEffect } from "react";
import styled from "styled-components";

// --- Styled Components ---
const MatchContainer = styled.div`
  
  padding: 15px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  max-width: 600px;
  margin: auto;
  margin-top: 20px;
`;

const MatchForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
`;

const Button = styled.button`
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  background: ${(props) => props.color || "#234ffc"};
  color: white;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.hover || "#123eeb"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const MatchItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
`;

export default function MatchManager({ rocznikId }) {
    const [matches, setMatches] = useState([]);
    const [formData, setFormData] = useState({
        opponentName: "",
        opponentLogo: "",
        date: "",
        time: "",
        address: "",
    });
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchMatches = async () => {
        try {
            const res = await fetch(`https://api.pth-hokej.pl/api/matches/rocznik/${rocznikId}`);
            const data = await res.json();
            setMatches(data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (rocznikId) fetchMatches();
    }, [rocznikId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (editingId) {
                await fetch(`https://api.pth-hokej.pl/api/matches/${editingId}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...formData, rocznik: rocznikId }),
                });
                setEditingId(null);
            } else {
                await fetch("https://api.pth-hokej.pl/api/matches", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...formData, rocznik: rocznikId }),
                });
            }

            setFormData({
                opponentName: "",
                opponentLogo: "",
                date: "",
                time: "",
                address: "",
            });
            fetchMatches();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (match) => {
        setEditingId(match._id);
        setFormData({
            opponentName: match.opponentName || "",
            opponentLogo: match.opponentLogo || "",
            date: match.date || "",
            time: match.time || "",
            address: match.address || "",
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Na pewno chcesz usunąć ten mecz?")) return;
        try {
            await fetch(`https://api.pth-hokej.pl5/api/matches/${id}`, { method: "DELETE" });
            fetchMatches();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <MatchContainer>
            <h3>{editingId ? "Edytuj mecz" : "Dodaj nowy mecz"}</h3>
            <MatchForm onSubmit={handleSubmit}>
                <Input
                    name="opponentName"
                    placeholder="Nazwa rywala"
                    value={formData.opponentName}
                    onChange={handleChange}
                    required
                />
                <Input
                    name="opponentLogo"
                    placeholder="Logo rywala (URL)"
                    value={formData.opponentLogo}
                    onChange={handleChange}
                />
                <Input
                    name="date"
                    type="date"
                    value={formData.date}
                    onChange={handleChange}
                    required
                />
                <Input
                    name="time"
                    type="time"
                    value={formData.time}
                    onChange={handleChange}
                    required
                />
                <Input
                    name="address"
                    placeholder="Adres meczu"
                    value={formData.address}
                    onChange={handleChange}
                    required
                />
                <Button type="submit" disabled={loading}>
                    {editingId ? "Zaktualizuj" : "Dodaj"}
                </Button>
                {editingId && (
                    <Button
                        type="button"
                        color="#5bc0de"
                        hover="#31b0d5"
                        onClick={() => {
                            setEditingId(null);
                            setFormData({
                                opponentName: "",
                                opponentLogo: "",
                                date: "",
                                time: "",
                                address: "",
                            });
                        }}
                    >
                        Dodaj nowy
                    </Button>
                )}
            </MatchForm>

            <h4>Lista meczów</h4>
            {matches.map((m) => (
                <MatchItem key={m._id}>
                    <div>
                        <strong>{m.opponentName}</strong> – {m.date} {m.time} @ {m.address}
                    </div>
                    <div>
                        <Button onClick={() => handleEdit(m)} style={{ marginRight: "8px" }} color="#f0ad4e" hover="#ec971f">
                            Edycja
                        </Button>
                        <Button onClick={() => handleDelete(m._id)} color="#d9534f" hover="#c9302c">
                            Usuń
                        </Button>
                    </div>
                </MatchItem>
            ))}
        </MatchContainer>
    );
}
